<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="未收票合同列表" name="未收票合同列表" class="tab-text">
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select @change="changeColumn(params.column)" v-model="params.column">
                    <el-option
                      v-for="(item, index) in contractScreenCondition"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="4"
                v-if="
                  params.column === 'contractMoney' ||
                    params.column === 'noInvoice'
                "
              >
                <el-form-item>
                  <el-select v-model="params.expression">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                      v-for="(item, index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-if="
                      params.column === undefined ||
                        params.column === 'pcbNumber' ||
                        params.column === 'supplierContractNumber' ||
                        params.column === 'suName' ||
                        params.column === 'noInvoice' ||
                        params.column === 'contractMoney'
                    "
                    v-model="params.value"
                    placeholder="请输入关键词"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-select
                    v-if="
                      params.column === 'payType' ||
                        params.column === 'contractState' ||
                        params.column === 'contractFrom'
                    "
                    v-model="params.value"
                  >
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in selsectStatus"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column === 'createDate'">
                <el-form-item>
                  <el-date-picker
                    style="width:100%;"
                    v-model="time"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col
                :span="(params.column === 'contractMoney' ||
                    params.column === 'noInvoice')? 10: 14"
              >
                <el-form-item>
                  <el-button @click="search" type="primary">搜索</el-button>
                  <el-button @click="resetSearch" type>重置</el-button>
                  <el-button
                    style="float:right;"
                    @click="onConsolidatedRceipt"
                    type="primary"
                    plain
                  >合并收票</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height: tableHeight+'px'}">
            <el-table
              border
              ref="tableRef"
              :max-height="tableHeight"
              :data="list"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              @selection-change="handleSelectionChange"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column fixed type="selection" width="55"></el-table-column>
              <el-table-column show-overflow-tooltip prop="contractFrom" label="合同类型"></el-table-column>
              <el-table-column show-overflow-tooltip prop="pcbNumber" width="150px" label="合同编号">
                <template slot-scope="scope">
                  <span
                    class="approval"
                    @click="pcbIdSkip(scope.row.pcbId,scope.row.contractState)"
                  >{{ scope.row.pcbNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="supplierContractNumber"
                label="供应商合同编号"
                width="130px"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.supplierContractNumber||'--' }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="suName" label="供应商名称" width="200px">
                <template slot-scope="scope">
                  <div
                    class="approval line-limit-length"
                    @click="suIdSkip(scope.row.suId)"
                  >{{ scope.row.suName }}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="payType" label="付款类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.payType||'--' }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="noInvoice" label="未收票金额" width="100px">
                <template slot-scope="scope">{{scope.row.noInvoice|priceFilterNum }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="contractMoney" label="合同总额">
                <template slot-scope="scope">{{scope.row.contractMoney|priceFilterNum }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="contractState" label="合同状态">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ dataList[scope.row.contractState - 1] }}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="deliverState" label="发货状态"></el-table-column>
              <el-table-column show-overflow-tooltip prop="actualTotal" label="已付账款">
                <template slot-scope="scope">{{scope.row.actualTotal|priceFilterNum }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="dueMoney" label="已到期账款" width="100px">
                <template slot-scope="scope">{{scope.row.dueMoney|priceFilterNum }}</template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="invoiceState" label="收票状态">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.invoiceState }}</div>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="staffUsename"
                label="当前负责人"
                width="100px"
              >
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.staffUsename||'--' }}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="orgName" label="所属部门">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.orgName||'--' }}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip width="150px" prop="createDate" label="签订时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              :currentPage="currentPage"
              :pageSize="pageSize"
            ></pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="合并收票列表" name="合并收票列表" class="tab-text">
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select @change="changeColumn(params.column)" v-model="params.column">
                    <el-option
                      v-for="(item, index) in contractScreenConditionMerge"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="4"
                v-if="
                  params.column === 'amount' ||
                    params.column === 'taxAmount'
                "
              >
                <el-form-item>
                  <el-select v-model="params.expression">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                      v-for="(item, index) in expressionList"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-if="
                      params.column === undefined ||
                        params.column === 'invoiceReceiveNumber' ||
                        params.column === 'invoiceReceiveCompany' ||
                        params.column === 'invoiceNumber' ||
                        params.column === 'amount' ||
                        params.column === 'taxAmount'||
                        params.column ==='processUser'
                    "
                    v-model="params.value"
                    placeholder="请输入关键词"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-select
                    v-if="
                      params.column === 'invoiceType'"
                    v-model="params.value"
                  >
                    <el-option
                      :label="item.label"
                      :value="item.value"
                      v-for="(item, index) in selsectStatus"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="6"
                v-if="params.column === 'invoiceReceiveDate'||params.column === 'createDate'"
              >
                <el-form-item>
                  <el-date-picker
                    style="width:100%;"
                    v-model="time"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button @click="search" type="primary">搜索</el-button>
                  <el-button @click="resetSearch" type>重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height: tableHeight+'px'}">
            <el-table
              border
              ref="tableRef"
              :data="listMerge"
              :max-height="tableHeight"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column
                show-overflow-tooltip
                prop="invoiceReceiveNumber"
                label="收票编号"
                width="150px"
              >
                <template slot-scope="scope">
                  <span
                    @click="invoiceReceiveNumberClick(scope.row.invoiceReceiveNumber)"
                    class="approval"
                  >{{ scope.row.invoiceReceiveNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="invoiceReceiveCompany"
                width="200px"
                label="公司名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceReceiveCompany }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="invoiceNumber"
                label="发票编号"
                width="130px"
              ></el-table-column>
              <el-table-column show-overflow-tooltip prop="amount" label="发票金额" width="100px">
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="taxAmount" label="税额">
                <template slot-scope="scope">
                  <span>{{ scope.row.taxAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="createDate" label="申请时间" width="150px">
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate|dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="invoiceType" label="发票类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceType }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="bilingType" label="收票类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.bilingType }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="state" label="收票状态">
                <template slot-scope="scope">
                  <span>{{selsectStatusOut[scope.row.state-1 ] }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="invoiceReceiveDate"
                label="收票时间"
                width="150px"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceReceiveDate|dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="processUser" label="处理人" width="100px"></el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-------------- 合并收票二次确认 -------------->
    <open-or-close
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import { deepClone } from '@/util'
import pagination from '@/components/pagination'
import OpenOrClose from '@/components/OpenOrClose/index'
import { formatDate, resetTableLayout } from '@/util/tool'
import {
  queryNoticket,
  queryMergePage,
  queryCompletedMergePage
} from '@/api/purchase/purchasePlanList'

export default {
  components: {
    pagination: pagination,
    'open-or-close': OpenOrClose
  },
  data () {
    return {
      tableHeight: window.innerHeight - 380,
      activeName: '未收票合同列表',
      expressionList: expressionList,
      params: {
        column: 'suName'
      },
      paramsList: {},
      list: [],
      listMerge: [],
      time: [],
      loadingTable: false,
      contractScreenCondition: [
        { label: '合同类型', value: 'contractFrom' },
        { label: '合同编号', value: 'pcbNumber' },
        { label: '供应商合同编号', value: 'supplierContractNumber' },
        { label: '供应商名称', value: 'suName' },
        { label: '付款类型', value: 'payType' },
        { label: '未收票金额', value: 'noInvoice' },
        { label: '合同金额', value: 'contractMoney' },
        { label: '合同状态', value: 'contractState' },
        { label: '签订时间', value: 'createDate' }
      ], // 筛选条件
      contractScreenConditionMerge: [
        { label: '收票编号', value: 'invoiceReceiveNumber' },
        { label: '公司名称', value: 'invoiceReceiveCompany' },
        { label: '发票编号', value: 'invoiceNumber' },
        { label: '发票金额', value: 'amount' },
        { label: '税额', value: 'taxAmount' },
        { label: '申请时间', value: 'createDate' },
        { label: '发票类型', value: 'invoiceType' },
        { label: '收票时间', value: 'invoiceReceiveDate' },
        { label: '处理人', value: 'processUser' }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 30,
      title: '',
      statusState: [],
      dataList: [
        '待审核',
        '审核中',
        '履行中',
        '已履行',
        '审核通过待签署',
        '已作废',
        '审核不通过',
        '审核驳回',
        '盖章审批'
      ],
      content: '',
      selsectStatus: [],
      selsectStatusOut: ['收票审核', '已收票', '已退票', '审核不通过', '退票中'],
      selsectStatuslist: [
        { label: '收票审核', value: 1 },
        { label: '已收票', value: 2 },
        { label: '审核不通过', value: 3 }
      ], // 收票状态
      invoiceStatuslist: [
        { label: '专用发票', value: '专用发票' },
        { label: '普通发票', value: '普通发票' }
      ], // 发票类型
      statusType: [
        { label: '采购合同', value: '采购合同' },
        { label: '售后维修', value: '售后维修' },
        { label: '售后退货', value: '售后退货' }
      ], // 合同类型
      statusList: [
        { label: '履行中', value: '3' },
        { label: '已履行', value: '4' }
      ], // 合同状态
      deliverList: [
        { label: '待发货', value: '待发货' },
        { label: '部分发货', value: '部分发货' },
        { label: '全部发货', value: '全部发货' }
      ], // 发货状态
      ticketList: [
        { label: '未收票', value: '未收票' },
        { label: '部分收票', value: '部分收票' }
      ], // 收票状态
      payList: [
        { label: '全款发货', value: '全款发货' },
        { label: '约定账期', value: '约定账期' },
        { label: '先货后款', value: '先货后款' }
      ], // 付款类型
      changePrice: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    pcbIdSkip (pcbId, status) {
      this.$router.push({
        name: 'contractDetails',
        query: { type: this.dataList[status - 1], pcbId: pcbId }
      })
    },
    suIdSkip (id) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: id }
      })
    },
    changeColumn (column) {
      this.time = []
      if (column === 'payType') {
        this.selsectStatus = this.payList
      } else if (column === 'contractState') {
        this.selsectStatus = this.statusList
      } else if (column === 'deliverState') {
        this.selsectStatus = this.deliverList
      } else if (column === 'invoiceState') {
        this.selsectStatus = this.ticketList
      } else if (column === 'contractFrom') {
        this.selsectStatus = this.statusType
      } else if (column === 'invoiceType') {
        this.selsectStatus = this.invoiceStatuslist
      } else if (column === 'state') {
        this.selsectStatus = this.selsectStatuslist
      }
      this.params = {
        column: column,
        expression: 'eq'
      }
    },

    search () {
      this.paramsList = deepClone(this.params)

      if (this.time && this.time.length === 2) {
        this.paramsList.value = this.time[0]
        this.paramsList.endValue = this.time[1]
      }
      if (
        this.paramsList.value === undefined ||
        this.paramsList.value === '' ||
        this.paramsList.column === undefined
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        if (this.activeName === '合并收票列表') {
          this.getListMerge()
        } else {
          this.getList()
        }
      }
    },
    resetSearch () {
      this.time = []
      if (this.activeName === '未收票合同列表') {
        this.params = {
          column: 'suName'
        }
      } else {
        this.params = {
        }
      }

      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      if (this.activeName === '合并收票列表') {
        this.getListMerge()
      } else {
        this.getList()
      }
    },
    handleSelectionChange (val) {
      this.changePrice = val
    },
    handleClick () {
      this.currentPage = 1
      this.pageSize = 30
      if (this.activeName === '合并收票列表') {
        this.params = {}
      } else {
        this.params = {
          column: 'suName'
        }
      }
      this.time = []
      this.paramsList = {}
      if (this.activeName === '合并收票列表') {
        this.getListMerge()
      } else {
        this.getList()
      }
    },
    getListMerge () {
      this.loadingTable = true
      this.listMerge = []
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryCompletedMergePage(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.listMerge = res.data.obj.records
            this.total = res.data.obj.total
            resetTableLayout.call(this, this.$refs.tableRef)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getList () {
      this.loadingTable = true
      this.list = []
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryNoticket(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            resetTableLayout.call(this, this.$refs.tableRef)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 合并收票
    onConsolidatedRceipt () {
      let price = 0
      if (this.changePrice.length < 2) {
        this.$message.error('请选择要合并的发票')
      } else {
        let isTrue = true
        this.changePrice.forEach((element) => {
          this.changePrice.forEach((item) => {
            if (element.suName !== item.suName && isTrue) {
              this.$message.error('供应商不同无法合并收票！')
              isTrue = false
            }
          })
        })
        let isFlase = true
        if (isTrue) {
          this.changePrice.forEach((element) => {
            this.changePrice.forEach((item) => {
              if (element.contractFrom !== item.contractFrom && isFlase) {
                this.$message.error('合同类型不同无法合并收票！')
                isFlase = false
              }
            })
          })
        }
        if (isTrue && isFlase) {
          this.changePrice.forEach((element) => {
            price += element.noInvoice * 100
          })
          this.title = '确定合并收票'
          this.content = '本次合并收票金额' + price / 100 + '元，确定合并收票？'
          this.$refs.openOrCloseRefs.onInitial()
        }
      }
    },
    invoiceReceiveNumberClick (val) {
      this.$router.push({
        name: 'ticketCollectionDetails',
        query: {
          invoiceReceiveNumber: val,
          type: 'merge'
        }
      })
    },
    onUpdataState () {
      const params = []
      for (let i = 0; i < this.changePrice.length; i++) {
        const obj = {
          pcbId: this.changePrice[i].pcbId,
          contractFrom: this.changePrice[i].contractFrom,
          suName: this.changePrice[i].suName
        }
        params.push(obj)
      }

      queryMergePage(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$store.state.ticketState = res.data.obj
            this.$router.push({
              name: 'applyForTicketCollection'
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      if (this.activeName === '合并收票列表') {
        this.getListMerge()
      } else {
        this.getList()
      }
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.activeName === '合并收票列表') {
        this.getListMerge()
      } else {
        this.getList()
      }
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
